import { render } from "./PetaSpklu.vue?vue&type=template&id=315ee632&scoped=true&ts=true"
import script from "./PetaSpklu.vue?vue&type=script&lang=ts"
export * from "./PetaSpklu.vue?vue&type=script&lang=ts"

import "./PetaSpklu.vue?vue&type=style&index=0&id=315ee632&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-315ee632"]])

export default __exports__